import React, { useEffect, useState } from 'react';
import './style.css';
import { INPUT_AUTOFILL_PROPS } from '../../../../../components/InputField/autofillProps';
import PreviousValue from '../../../../../components/InputField/PreviousValue';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

const PercentageInput = ({ id, required, value, label, onChange, onCommit, isDisabled, className, handleValidation, error, showErr, prevValue }) => {
    const [inputValue, setInputValue] = useState('');
    const fieldTestId = resolveAutomationTestId(id, label);

    useEffect(() => {
        if (value != null) {
            const str = typeof value === 'number' ? String(value) : String(value);
            setInputValue(str.replace('%', ''));
        } else {
            setInputValue('');
        }
    }, [value]);

    const handleInputChange = (e) => {
        let inputValue = e.target.value.replace(/[^\d.]/g, ''); // Remove any non-digit or non-decimal point characters

        // Ensure there is only one decimal point
        const parts = inputValue.split('.');
        if (parts.length > 2) {
            inputValue = parts.slice(0, 2).join('.') + '.' + parts.slice(2).join('');
        }

        if (inputValue !== '') {
            // Update the state with the sanitized input value
            setInputValue(inputValue);
            onChange(inputValue);
        } else {
            // If the input is empty, update the state with an empty string
            setInputValue('');
            onChange('');
        }
    };



    const handleBlur = () => {
        if (inputValue !== '' && !inputValue.includes('%')) {
            setInputValue(inputValue + '%');
        }
        onCommit?.(inputValue.replace('%', ''));
    };

    const handleFocus = () => {
        setInputValue(inputValue.replace('%', ''));
    };

    const handleKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        const charStr = String.fromCharCode(charCode);

        // Allow only numeric input, backspace, and decimal point
        if (!/^\d$/.test(charStr) && charCode !== 8 && charStr !== '.') {
            e.preventDefault();
        }

        // Check for existing decimal point
        if (charStr === '.' && e.target.value.includes('.')) {
            e.preventDefault();
        }

        // Check the input value
        const inputValue = e.target.value.replace('%', '');
        const newValue = parseFloat(inputValue + charStr);
        if (newValue > 100) {
            e.preventDefault();
        }
    };


    return (
        <div className="col-sm-6" data-testid={fieldTestId}>
            <label className='mb-0' data-testid={buildAutomationChildTestId(fieldTestId, "label")} style={{ marginTop: "10px", fontSize: "16px", fontWeight: "500" }}>{label}             {required && <font color="red">*</font>}</label>

            <div className="percentage-input-container">
                <input
                    id={id}
                    data-testid={buildAutomationChildTestId(fieldTestId, "input")}
                    {...INPUT_AUTOFILL_PROPS}
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className={`${className} ${prevValue?.has ? "is-changed" : isDisabled ? "is-disabled" : ""}`}
                    onFocus={handleFocus}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter a Percentage of Ownership"
                    disabled={isDisabled}
                    style={{
                        border: "none",
                        padding: "12px",
                        background: prevValue?.has ? "#FFF9D6" : isDisabled ? "#F6F6F6" : "#f1fafc",
                        borderRadius: "10px",
                        outline: "none",
                        marginTop: "5px",
                        width: "100%"
                    }}
                />
                <PreviousValue
                    show={prevValue?.has}
                    value={prevValue?.value ? `${prevValue.value}%` : ""}
                    testId={buildAutomationChildTestId(fieldTestId, "previous")}
                />
                {error && showErr && (
                    <em className="inputfield__error" data-testid={buildAutomationChildTestId(fieldTestId, "error")}>
                        {error ? error : "Please enter Something"}
                    </em>
                )}
            </div>
        </div>
    );
};

export default PercentageInput;
